import { useState } from 'react'
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

import Button from "../../../common/Button"
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import ShareLinkDocument from "../procodocs/documents/controls/ShareLinkDocument";

import classes from './DocumentCell.module.css'
import ViewDocument from '../procodocs/documents/controls/ViewDocument';
import DownloadDocument from '../procodocs/documents/controls/DownloadDocument';
import DownloadConfirmation from '../procodocs/documents/DownloadConfirmation';
import { documentHasFileId } from '../../../../lib/docs';

const DocumentCell = ({file, isPrevious, parent, isNormalDoc, isDeleted = false}) => {
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    
    const [openDownloadConfirmation, setOpenDownloadConfirmation] = useState(false)
    const [openViewConfirmation, setOpenViewConfirmation] = useState(false)
    const downloadFileHandler = () => {
        setOpenDownloadConfirmation(prevState => prevState = !prevState)
    }

    const viewFileHandler = () => {
        setOpenViewConfirmation(prevState => prevState = !prevState)
    }

    return <div className={classes.item}>
        {file.name}
        {!isDeleted && <div className={classes.btn_container}>
            {!isPrevious && <>
                <ShareLinkDocument userToken={userToken} activeCase={activeCase} item={file} docType={'document'} isNormalDoc={isNormalDoc}/>
                <ViewDocument userToken={userToken} activeCase={activeCase} item={file} btnStyle='btn_simple' docType={'document'}>
                    <i className="ti ti-eye"></i>
                </ViewDocument>
                <DownloadDocument userToken={userToken} activeCase={activeCase} item={file} btnStyle='btn_simple' docType={'document'}>
                    <i className="ti ti-download"></i>
                </DownloadDocument>   
            </>}
            {isPrevious && documentHasFileId(file) && <>
                <Button btnStyle={'btn_simple'} click={viewFileHandler}>
                    <i className="ti ti-eye"></i>
                    <span className="sr-only">view {file.name}</span>
                </Button>
                <Button btnStyle={'btn_simple'} click={downloadFileHandler}>
                    <i className="ti ti-download"></i>
                    <span className="sr-only">download {file.name}</span>
                </Button>
            </>}
        </div>}

        {!isDeleted && openDownloadConfirmation && <>
            {ReactDOM.createPortal(
                <Backdrop hide={downloadFileHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={downloadFileHandler} modalTitle={'Download File?'}>
                        <DownloadConfirmation closeModal={downloadFileHandler} parent={parent} activeCase={activeCase} file={file} docType={'document'} userToken={userToken}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}

        {!isDeleted && openViewConfirmation && <>
            {ReactDOM.createPortal(
                <Backdrop hide={viewFileHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={viewFileHandler} modalTitle={'View File?'}>
                        <DownloadConfirmation closeModal={viewFileHandler} parent={parent} activeCase={activeCase} file={file} isView={true} docType={'document'} userToken={userToken}/>
                    </ModalInnerWrapper>
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}

export default DocumentCell